import React from "react";
import PropTypes from "prop-types";
import { pure } from "recompose";
import { defineMessages, injectIntl, FormattedMessage } from "react-intl";
import { ViewListIcon, ListIcon, MapIcon, MarkerMapIcon } from "../../theme/assets";
import classnames from "classnames";
import styles from "./ViewSelector.scss";
export const msgs = defineMessages({
  mapView: {
    id: "viewSelector.mapView",
    description: "map view",
    defaultMessage: "map",
  },
  listView: {
    id: "viewSelector.listView",
    description: "list view",
    defaultMessage: "list",
  },
});

function Separator() {
  return <div className={classnames("wbkv9-ViewSelector-Separator", styles.Separator)}></div>;
}

function IconButton({ icon, msg, className, onClick }) {
  return (
    <div
      onClick={onClick}
      className={classnames(className, "wbkv9-ViewSelector-IconButton", styles.IconButton)}>
      {icon}

      {msg && (
        <div className={classnames("wbkv9-ViewSelector-IconButton-title", styles.title)}>
          <FormattedMessage {...msg} />
        </div>
      )}
    </div>
  );
}

const VIEW_LIST = "LIST";
const VIEW_MAP = "MAP";

function ViewSelector({ onMapClick, onListClick, activeView, fullWidth }) {
  return (
    <div className={classnames("wbkv9-ViewSelector", styles.ViewSelector)}>
      <IconButton
        className={[
          "wbkv9-ViewSelector-IconButton-ViewList",
          styles.list,
          activeView === VIEW_LIST && styles.active,
        ]}
        onClick={onListClick}
        msg={!fullWidth && msgs.listView}
        icon={(fullWidth && <ListIcon />) || <ViewListIcon />}
      />

      {!fullWidth && <Separator />}

      <IconButton
        className={[
          "wbkv9-ViewSelector-IconButton-ViewMap",
          styles.map,
          activeView === VIEW_MAP && styles.active,
        ]}
        onClick={onMapClick}
        msg={!fullWidth && msgs.mapView}
        icon={(fullWidth && <MarkerMapIcon />) || <MapIcon />}
      />
    </div>
  );
}

ViewSelector.propTypes = {
  items: PropTypes.array.isRequired,
};

export default injectIntl(pure(ViewSelector));
